// Which recordings are safe to put through the resilient, AUTO-RETRYING durable
// queue (useIndexDb.checkRecordings)?
//
// The drain re-sends a queued recording whenever an upload attempt doesn't ack
// (lost response, 3-min PARSE_TIMEOUT on a slow-but-successful call, offline
// backoff). That is only safe when the backend can DEDUPE the retry — i.e. the
// operation is keyed by the stable `recordingId`. The main encounter dictation
// (and reassessment/procedure phases) upload via `api.transcript(..., recordingId)`,
// which the backend dedupes, so a retry can never double-create.
//
// Two voice actions hit endpoints that take NO recordingId and are therefore
// NOT idempotent — retrying them creates a SECOND artifact:
//   - quick_start  -> api.aiQuickStart(...)  : creates a brand-new encounter
//   - "AI Update Note" -> api.aiUpdateNote(...) : re-applies a section edit
// These must stay on the inline (live) path and must never be auto-re-queued; a
// failed attempt is surfaced to the user, who can simply trigger the action again.
export const QUICK_START_CHAT_ID = "quick_start";
export const AI_UPDATE_NOTE_PHASE = "AI Update Note";

// Returns true when a recording targets a non-idempotent endpoint and therefore
// must NOT be written ahead to / retried from the durable queue.
//
// THREE consumers depend on this exact set:
//   1. useIndexDb.checkRecordings  — never auto-re-queue these (would double-create).
//   2. useRecorder segmented path  — never stream these as manifest + segments.
//   3. usePostMessages syncRecording — never register the stalled-capsule hand-back
//      for these. That handler returns a recording to the shell as "error" so its
//      retry backoff re-offers it, which for these two endpoints would create a
//      SECOND encounter / re-apply a section edit. Stranding is the lesser evil, so
//      they get no handler and no retry affordance.
//      Quick Start has no real encounter yet, so the platform `chat` scope would
//      be the "quick_start" placeholder, which the platform rejects with
//      422 "The chat (quick_start) is not valid". AI Update Note saves via a
//      non-transcript endpoint the segment-assembly model doesn't fit. Both must
//      stay on the inline single-blob path. Keep these two reasons in sync if the
//      predicate ever changes.
export const isNonIdempotentRecording = (chatId, phase) => chatId === QUICK_START_CHAT_ID || phase === AI_UPDATE_NOTE_PHASE;
